import type { CSSProperties } from 'vue';

const SITE_COLOR_PALETTE = [
  '#0d9488',
  '#2563eb',
  '#7c3aed',
  '#ea580c',
  '#db2777',
  '#0891b2',
  '#4f46e5',
  '#16a34a',
  '#ca8a04',
  '#dc2626',
] as const;

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/** Stable color for a node when the user has not set a preference yet. */
export function siteColorFallback(nodeId: string): string {
  const key = (nodeId || '').trim();
  if (!key) return SITE_COLOR_PALETTE[0];
  return SITE_COLOR_PALETTE[hashString(key) % SITE_COLOR_PALETTE.length];
}

export function resolveSiteColor(color?: string | null, nodeId?: string): string {
  const trimmed = (color || '').trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return trimmed;
  return siteColorFallback(nodeId || '');
}

/** Pill styles for site labels (patients, dashboard, sites cards). */
export function sitePillStyle(color?: string | null, nodeId?: string): CSSProperties {
  const resolved = resolveSiteColor(color, nodeId);
  return {
    backgroundColor: `${resolved}24`,
    borderColor: `${resolved}52`,
    color: resolved,
  };
}

/** Accent bar / left border for site sections. */
export function siteAccentStyle(color?: string | null, nodeId?: string): CSSProperties {
  const resolved = resolveSiteColor(color, nodeId);
  return {
    backgroundColor: resolved,
    borderColor: resolved,
  };
}
